<template>
  <v-menu v-bind="$attrs">
    <template #activator="{ on, attrs }">
      <v-btn outlined elevation small color="primary" v-bind="attrs" v-on="on">
        {{ labelSelected }}
        <v-icon>mdi-menu-down</v-icon>
      </v-btn>
    </template>
    <section class="list_menu">
      <SimpleCheckbox
        v-for="item in itemsFormatted"
        :key="item.value"
        :item="item"
        v-model="selected"
      >
        <template #label>
          <slot v-if="$scopedSlots.item" name="item" :item="item" />
          <div class="label_item" v-else>
            <p class="ma-0 pa-0 text-body-1 text--primary">
              {{ item.text }}
            </p>
          </div>
        </template>
      </SimpleCheckbox>
    </section>
  </v-menu>
</template>
<script>
export default {
  name: "SimpleMenu",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    value: {
      type: [Array, String],
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: "Seleccionar"
    }
  },
  components: {
    SimpleCheckbox: () => import("./SimpleCheckbox.vue")
  },
  data() {
    return {};
  },
  computed: {
    labelSelected() {
      if (!this.multiple) return this.selected || this.label;

      if (!this.selected || this.selected.length === 0) return this.label;
      if (this.selected.length === 1) return this.selected[0];
      return `${this.selected[0]} +${this.selected.length} seleccionados`;
    },
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    itemsFormatted() {
      return this.items.map(item =>
        this.formatItem(item, this.itemText, this.itemValue)
      );
    }
  },
  methods: {
    formatItem(item, keyText = "text", keyValue = "value") {
      if (typeof item === "string") {
        return { text: item, value: item, disabled: false };
      }
      return {
        text: item[keyText],
        value: item[keyValue],
        disabled: item.disabled || false
      };
    }
  }
};
</script>

<style scoped>
.list_menu {
  background-color: white;
  padding: 0.5rem;
}
</style>
